import { Capacitor } from '@capacitor/core';
import './styles.css';
import { App } from './app/App';

function bootstrap(): void {
  const canvas = document.getElementById('game-canvas');
  const hud = document.getElementById('hud');
  if (!(canvas instanceof HTMLCanvasElement)) throw new Error('#game-canvas not found');
  if (!(hud instanceof HTMLElement)) throw new Error('#hud not found');
  new App(canvas, hud);
}

bootstrap();

// Android's hardware/gesture back button has no web equivalent — left
// unhandled, Capacitor's default is to kill the activity, which would drop the
// player's room seat and WebSocket without a chance to confirm. The app has no
// in-app router/history to "go back" through (it's all overlay panels), so the
// safe default recommended by Capacitor for exactly this shape of app is to
// background the app instead of exiting it — same as the Home button.
if (Capacitor.isNativePlatform()) {
  void import('@capacitor/app').then(({ App: CapApp }) => {
    CapApp.addListener('backButton', () => void CapApp.minimizeApp());
  });
}
